import { IBrandOrder } from "@faire/web-api--source/indigofair/data/IBrandOrder";

import { InstantAnswerContext } from "../../../types";

export const isOrderReplaced = (context: InstantAnswerContext) => {
  const { brandOrder } = context;
  const creationReason = brandOrder?.brand_order?.creation_reason;

  return (
    creationReason ===
    IBrandOrder.CreationReason.REPLACE_DAMAGED_OR_MISSING_ITEMS
  );
};
